function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_18566",
  "data-name": "Group 18566",
  transform: "translate(-236.5 -1234.752)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18560",
  "data-name": "Group 18560",
  transform: "translate(-562 712.752)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_2205",
  "data-name": "Line 2205",
  x2: 45.5,
  transform: "translate(857 523)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2207",
  "data-name": "Line 2207",
  x2: 13.5,
  transform: "translate(804.5 600.213)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2206",
  "data-name": "Line 2206",
  x2: 25.5,
  transform: "translate(857 534)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2208",
  "data-name": "Line 2208",
  x2: 25.5,
  transform: "translate(799 609.213)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_18017",
  "data-name": "Group 18017",
  transform: "translate(886.003 599.497)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(5)",
  fill: "#cad4dd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(12 5) rotate(90)",
  fill: "#cad4dd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_18018",
  "data-name": "Group 18018",
  transform: "translate(798.5 534)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(5)",
  fill: "#cad4dd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 2,
  height: 12,
  rx: 1,
  transform: "translate(12 5) rotate(90)",
  fill: "#cad4dd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2885",
  "data-name": "Ellipse 2885",
  transform: "translate(849 620.497)",
  fill: "#fff",
  stroke: "#cad4dd",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 3.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_040-skills",
  "data-name": "040-skills",
  transform: "translate(254.607 1235.751)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31763",
  "data-name": "Path 31763",
  d: "M348.331,407.671H326.378a1,1,0,0,1-1.061-1.061v-3.924a6.02,6.02,0,0,1,3.076-5.3l8.378-4.56a.964.964,0,0,1,1.061,0l8.378,4.56a6.02,6.02,0,0,1,3.076,5.3v3.924A.878.878,0,0,1,348.331,407.671Zm-20.893-2.121h19.832v-2.864a3.8,3.8,0,0,0-2.015-3.394l-7.954-4.348-7.954,4.348a3.8,3.8,0,0,0-2.015,3.394v2.864Z",
  transform: "translate(-281.516 -339.795)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31765",
  "data-name": "Path 31765",
  d: "M185.96,407.671H164.113a1,1,0,0,1-1.061-1.061v-3.924a6.02,6.02,0,0,1,3.076-5.3l8.378-4.56a.964.964,0,0,1,1.061,0l8.378,4.56a6.02,6.02,0,0,1,3.076,5.3v3.924A1,1,0,0,1,185.96,407.671Zm-20.787-2.121h19.832v-2.864a3.8,3.8,0,0,0-2.015-3.394l-7.954-4.348-7.954,4.348a3.8,3.8,0,0,0-2.015,3.394v2.864Z",
  transform: "translate(-141.098 -339.795)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31766",
  "data-name": "Path 31766",
  d: "M385.184,327.787c0,3.712-2.439,7.954-5.515,7.954s-5.515-4.136-5.515-7.954c0-3.712,2.439-5.621,5.515-5.621S385.184,324.075,385.184,327.787Z",
  transform: "translate(-323.777 -278.789)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31767",
  "data-name": "Path 31767",
  d: "M372.853,329.985c-3.712,0-6.575-4.773-6.575-9.015,0-4.03,2.651-6.682,6.575-6.682s6.576,2.651,6.576,6.682C379.428,325.213,376.564,329.985,372.853,329.985Zm0-13.469c-2.757,0-4.454,1.7-4.454,4.56,0,3.394,2.227,6.894,4.454,6.894s4.454-3.5,4.454-6.894C377.307,318.213,375.61,316.516,372.853,316.516Z",
  transform: "translate(-316.961 -271.973)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31768",
  "data-name": "Path 31768",
  d: "M222.132,327.787c0,3.712-2.439,7.954-5.515,7.954s-5.515-4.136-5.515-7.954c0-3.712,2.439-5.621,5.515-5.621S222.132,324.075,222.132,327.787Z",
  transform: "translate(-182.679 -278.789)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31769",
  "data-name": "Path 31769",
  d: "M209.8,329.985c-3.712,0-6.575-4.773-6.575-9.015,0-4.03,2.651-6.682,6.575-6.682s6.575,2.651,6.575,6.682C216.376,325.213,213.512,329.985,209.8,329.985Zm0-13.469c-2.757,0-4.454,1.7-4.454,4.56,0,3.394,2.227,6.894,4.454,6.894s4.454-3.5,4.454-6.894C214.255,318.213,212.558,316.516,209.8,316.516Z",
  transform: "translate(-175.862 -271.973)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31771",
  "data-name": "Path 31771",
  d: "M23.014,407.671H1.061A1,1,0,0,1,0,406.61v-3.924a6.02,6.02,0,0,1,3.076-5.3l8.378-4.56a.964.964,0,0,1,1.061,0l8.378,4.56a6.02,6.02,0,0,1,3.076,5.3v3.924A.923.923,0,0,1,23.014,407.671ZM2.121,405.55H21.954v-2.864a3.8,3.8,0,0,0-2.015-3.394l-7.954-4.348L4.03,399.292a3.8,3.8,0,0,0-2.015,3.394v2.864Z",
  transform: "translate(0 -339.795)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31772",
  "data-name": "Path 31772",
  d: "M59.079,327.787c0,3.712-2.439,7.954-5.515,7.954s-5.515-4.136-5.515-7.954c0-3.712,2.439-5.621,5.515-5.621S59.079,324.075,59.079,327.787Z",
  transform: "translate(-41.58 -278.789)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31773",
  "data-name": "Path 31773",
  d: "M46.747,329.985c-3.712,0-6.575-4.773-6.575-9.015,0-4.03,2.651-6.682,6.575-6.682a6.319,6.319,0,0,1,6.575,6.682C53.323,325.213,50.566,329.985,46.747,329.985Zm0-13.469c-2.757,0-4.454,1.7-4.454,4.56,0,3.394,2.227,6.894,4.454,6.894s4.454-3.5,4.454-6.894C51.2,318.213,49.611,316.516,46.747,316.516Z",
  transform: "translate(-34.763 -271.973)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("g", {
  id: "star",
  transform: "translate(6.48 26.156)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31775",
  "data-name": "Path 31775",
  d: "M1.975,11a.365.365,0,0,0,.514.408L5.511,9.857,8.532,11.41A.365.365,0,0,0,9.046,11L8.475,7.746,10.9,5.436a.383.383,0,0,0-.195-.654L7.334,4.3,5.83,1.324a.353.353,0,0,0-.638,0L3.688,4.3.316,4.782a.383.383,0,0,0-.195.654l2.425,2.31L1.975,11ZM5.352,9.1,2.815,10.4l.478-2.724a.389.389,0,0,0-.112-.348l-2-1.907,2.79-.4a.361.361,0,0,0,.27-.2L5.511,2.309,6.782,4.827a.361.361,0,0,0,.27.2l2.79.4-2,1.907a.388.388,0,0,0-.112.348L8.207,10.4,5.67,9.1a.346.346,0,0,0-.317,0Z",
  fill: "#cad4dd",
  stroke: "#8c9cac",
  strokeWidth: 1,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "star-2",
  "data-name": "star",
  transform: "translate(27.359 26.156)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31775-2",
  "data-name": "Path 31775",
  d: "M1.975,11a.365.365,0,0,0,.514.408L5.511,9.857,8.532,11.41A.365.365,0,0,0,9.046,11L8.475,7.746,10.9,5.436a.383.383,0,0,0-.195-.654L7.334,4.3,5.83,1.324a.353.353,0,0,0-.638,0L3.688,4.3.316,4.782a.383.383,0,0,0-.195.654l2.425,2.31L1.975,11ZM5.352,9.1,2.815,10.4l.478-2.724a.389.389,0,0,0-.112-.348l-2-1.907,2.79-.4a.361.361,0,0,0,.27-.2L5.511,2.309,6.782,4.827a.361.361,0,0,0,.27.2l2.79.4-2,1.907a.388.388,0,0,0-.112.348L8.207,10.4,5.67,9.1a.346.346,0,0,0-.317,0Z",
  fill: "#f3994e",
  stroke: "#f3994e",
  strokeWidth: 1,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "star-3",
  "data-name": "star",
  transform: "translate(49.359 26.156)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31775-3",
  "data-name": "Path 31775",
  d: "M1.975,11a.365.365,0,0,0,.514.408L5.511,9.857,8.532,11.41A.365.365,0,0,0,9.046,11L8.475,7.746,10.9,5.436a.383.383,0,0,0-.195-.654L7.334,4.3,5.83,1.324a.353.353,0,0,0-.638,0L3.688,4.3.316,4.782a.383.383,0,0,0-.195.654l2.425,2.31L1.975,11Z",
  fill: "#f3994e",
  fillRule: "evenodd"
}))));

function SvgRatingEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 107.497,
    viewBox: "0 0 104 107.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingEmpty);
export default __webpack_public_path__ + "static/media/ratingEmpty.d8ac47d6.svg";
export { ForwardRef as ReactComponent };